import { Progress, Button } from 'antd'
import { CheckOutlined, ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { connect } from 'react-redux'
import { useState } from "react"
import { usePoller } from "Hooks"
import { useRouteMatch, useHistory } from 'react-router-dom'
import moment from 'moment'

const statusMap = {
  'running': 'active',
  'pending': 'normal',
  'errored': 'exception',
  'success': 'success',
}

function ProgressPoller ({ plugins, selectedQtr, setWaitingForJobs, jobTimestamp, refetch }) {

  const { params: { spaceId }} = useRouteMatch()
  const history = useHistory()
  const [scheduleUid, setScheduleUid] = useState(undefined)
  const [loading, setLoading] = useState(true)
  const [job, setJob] = useState(undefined)

  const orchestrator = plugins['weaver-orchestrator']

  const getMatchedQtr = async () => {
    const [selectedYear, selectedQuarter] = selectedQtr
    const schedules = await orchestrator.getSchedules()
    const parsedSchedules = JSON.parse(schedules)
    const pertinentTasks = parsedSchedules.filter((t) => t.functionalityName === "pmsccy.invoice")
    return pertinentTasks.filter((t) => (t.config.year === parseInt(selectedYear) & t.config.quarter === parseInt(selectedQuarter.substring(1))))
  }

  const getRelevantUid = (matchedQtr) => {
    const sortedQtrs = matchedQtr.sort((a, b) => new Date(a.created) - new Date(b.created))
    return sortedQtrs.slice(-1)[0]?.uid
  }

  const pollerCallback = async () => {
    const matchedQtr = await getMatchedQtr()
    if (matchedQtr.length === 0) {
      return undefined
    }
    const relevantUid = getRelevantUid(matchedQtr)
    setScheduleUid(relevantUid)
    const jobs = await orchestrator.getJobs({ scheduleUid: relevantUid })
    const sortedJobs = JSON.parse(jobs).sort((a, b) => new Date(a.started) - new Date(b.started))
    const relevantInvoiceBeingGenerated = sortedJobs.find((j) => moment(j.started).valueOf() > jobTimestamp && j.status === 'running')
    if (relevantInvoiceBeingGenerated) {
      setWaitingForJobs(true);
    } else {
      setWaitingForJobs(false);
    }
    setJob(sortedJobs.slice(-1)[0])
    setLoading(false)
  }

  usePoller(async () => await pollerCallback(), 10000)

  const progressUI = (
    <Progress
      style={{ margin: '0px 5px' }}
      type="circle"
      status={statusMap[job?.status]}
      percent={job?.progress}
      format={(val) => {
        switch (job?.status) {
          case 'running':
            return `${val}%`
          case 'pending':
            return <ClockCircleOutlined />
          case 'success':
            refetch()
            return <CheckOutlined />
          case 'errored':
            return <CloseOutlined />
          default:
            return <ClockCircleOutlined />
        }
      }}
      size="small"
      width={22}
    />
  )

  const actionButton = (
    <Button
      style={{ padding: '0px 5px'}}
      onClick={() => {
        history.push({
          pathname: `/${ spaceId }/pipelines/tasks`,
          state: scheduleUid
        })
      }}
      type="text"
    >
      <a>{ loading ? "Factuurdata ophalen..." : "Toon meer" }</a>
    </Button>
  )

  const renderProgress = () => {
    if (job) {
      return (
        <>
          {progressUI}
          {actionButton}
        </>
      )
    } else {
      return null
    }
  }

  return renderProgress()
}

const mapStateToProps = ({ explore: { plugins }}) => ({ plugins })
export default connect(mapStateToProps, null)(ProgressPoller)
